import { MouseEvent, RefObject, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { ReactComponent as LinkIcon } from '../../../../assets/icons/link.svg'
import { ReactComponent as Pencil } from '../../../../assets/icons/pencil.svg'
import { ReactComponent as Thrash } from '../../../../assets/icons/trash.svg'
import { IResponse, useResponsesStore } from '../../../../stores/responsesStore'
import Bulb from '../../../Bulb/Bulb'
import EditResponseNavItem from '../EditResponseNavItem/EditResponseNavItem'

import { joinClassNames } from '../../../../utils/styles'
import styles from './response-nav-item.module.scss'

interface IResponseNavItem {
    response: IResponse
    responsesRef: RefObject<HTMLElement>
}

function ResponseNavItem(props: IResponseNavItem) {
    const { response, responsesRef } = props

    const { t } = useTranslation()

    const [
        { newResponseId, currentResponseId },
        { setCurrentResponseId, deleteResponse },
    ] = useResponsesStore()

    const [isResponseEditing, setIsResponseEditing] = useState(false)

    const handleStartEditing = (
        e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
    ) => {
        e.stopPropagation()

        setIsResponseEditing(true)
    }

    const handleDelete = (
        e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
    ) => {
        e.stopPropagation()

        deleteResponse(response.name)
    }

    const isResponseKeyActive =
        newResponseId === response.name ||
        (currentResponseId === response.name && !newResponseId)

    return (
        <div
            className={joinClassNames(
                styles.responseNavItem,
                isResponseKeyActive && styles.responseNavItemActive
            )}
            key={response.name}
            onClick={() =>
                !newResponseId && setCurrentResponseId(response.name)
            }
        >
            {isResponseEditing ? (
                <EditResponseNavItem
                    isActive={isResponseKeyActive}
                    response={response.name}
                    setIsResponseEditing={setIsResponseEditing}
                />
            ) : (
                <>
                    <div className={styles.responseNavItem__name}>
                        <Bulb
                            status={response.used}
                            scrollWrapperRef={responsesRef}
                            errorMessage={t('no_response_used')}
                        />
                        <p>{response.name}</p>
                    </div>

                    <div className={styles.responseNavItem__buttons}>
                        {response.intent ? (
                            <Link
                                className={styles.responseNavItem__btn}
                                to={`/training-data/data/faq_en?intents=${response.intent}`}
                            >
                                <LinkIcon />
                            </Link>
                        ) : null}
                        <button
                            className={styles.responseNavItem__btn}
                            onClick={handleStartEditing}
                        >
                            <Pencil />
                        </button>
                        <button
                            className={styles.responseNavItem__btn}
                            onClick={handleDelete}
                        >
                            <Thrash />
                        </button>
                    </div>
                </>
            )}
        </div>
    )
}

export default ResponseNavItem
